export default __webpack_public_path__ + "static/media/029-windmill.43ea368e.svg";